import React, { useEffect, useState } from 'react';
import AddDataModal from "./AddDataModal";
import EditDataModal from "./EditDataModal";
import Paginator from "../../components/common/Paginator/Paginator";
import { fileUrl } from "../../api/api";

const Product = React.memo(({ deleteProductTh, products, groups, ...props }) => {
    let [isEditProduct, setIsEditProduct] = useState(false);
    let [isCreateProduct, setIsCreateProduct] = useState(false);
    let [productId, setProductId] = useState();
    const [show, setShow] = useState(false);

    useEffect(() => {
        if (isCreateProduct) setShow(isCreateProduct);
    }, [isCreateProduct]);

    useEffect(() => {
        if (isEditProduct) setShow(isEditProduct);
    }, [isEditProduct]);

    const EditProduct = (event) => {
        setProductId(event.target.id);
        setIsEditProduct(true);
    };

    const AddProduct = () => {
        setIsCreateProduct(true);
    };
    let eventTypes = [
        { id: 1, name: "Tədbir", status: 1 },
        { id: 2, name: "Seminar", status: 1 },
        { id: 3, name: "Workshop", status: 1 }
    ];

    let productType = [
        { id: 1, name: "Nevrologiya", status: 1 },
        { id: 2, name: "Kardiologiya", status: 1 },
        { id: 3, name: "Travmatologiya", status: 1 },
        { id: 4, name: "Daxili xəstəliklər", status: 1 },
        { id: 5, name: "Revmatologiya", status: 1 },
        { id: 6, name: "Travmatalogiya", status: 1 },
        { id: 7, name: "Ortopediya", status: 1 },
        { id: 8, name: "Radiologiya", status: 1 },
        { id: 9, name: "İmmunologiya", status: 1 }
    ];
    const truncate = (value, max = 30) => {
        if (value === null || value === undefined) return '';
        const str = String(value);
        return str.length > max ? str.slice(0, max) + '…' : str;
    };

    let productsList = products?.map(product => (
        <tr key={product.productId}>
            <td>{product.productId}</td>
            <td title={product.title} style={{ maxWidth: "220px", overflow: "hidden", textOverflow: "ellipsis" }}>
                {truncate(product.title)}
            </td>
            <td>
                <img
                    style={{ width: "80px", height: "60px", objectFit: "cover", borderRadius: "4px" }}
                    src={`${fileUrl}${product.imgUrl}`}
                    alt={product.title}
                />
            </td>
            <td>
                {product.status === 1 ?
                    <span className="badge badge-pill badge-success">Active</span> :
                    <span className="badge badge-pill badge-danger">Deactive</span>
                }
            </td>
            <td>{productType.find(d => d.id === parseInt(product.productType))?.name || "Təyin edilməyib"}</td>
            <td>{eventTypes.find(e => e.id === parseInt(product.eventType))?.name || "Təyin edilməyib"}</td>
            <td>{product.price}</td>
            <td>{product.startDate?.substr(0, 16)}</td>
            <td>{product.endDate?.substr(0, 16)}</td>
            <td>
                <span className="badge bg-warning"
                      id={product.productId}
                      style={{ cursor: "pointer" }}
                      onClick={EditProduct}>Redaktə</span>
            </td>
        </tr>
    ));

    return (
        <div>
            {isCreateProduct &&
            <AddDataModal
                show={isCreateProduct}
                productTypes={productType}
                eventTypes={eventTypes}
                addProductTh={props.addProductTh}
                setIsCreateProduct={setIsCreateProduct}
                {...props}
            />
            }
            {isEditProduct && products && products.length > 0 &&
            <EditDataModal
                show={isEditProduct}
                setIsEditProduct={setIsEditProduct}
                productId={productId}
                products={products}
                updateProductTh={props.updateProductTh}
                deleteProductTh={deleteProductTh}
                productTypes={productType}
                eventTypes={eventTypes}
                {...props}
            />
            }
            <div className="card ml-1 mr-1">
                <div className="card-header">
                    <h3 className="card-title">Məhsul</h3>
                    <div className="card-tools">
                        <Paginator
                            totalElements={props.totalElements}
                            totalPages={props.totalPages}
                            size={props.size}
                            getNewPorsion={props.getProductsTh}
                        />
                    </div>
                </div>
                <div className="card-body p-0" style={{ overflowX: 'auto' }}>
                    <table className="table" style={{ whiteSpace: 'nowrap' }}>
                        <thead>
                        <tr>
                            <th style={{ width: "10px" }}>Id</th>
                            <th style={{ maxWidth: "220px" }}>Adı</th>
                            <th>imgUrl</th>
                            <th>status</th>
                            <th>Daxil Olduğu Sahə</th>
                            <th>Tədbir növü</th>
                            <th>price</th>
                            <th>startDate</th>
                            <th>endDate</th>
                            <th style={{ width: "40px" }}>
                                    <span className="badge bg-info"
                                          style={{ cursor: "pointer" }}
                                          onClick={AddProduct}>Əlavə Et</span>
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        {products ? productsList : <tr><td colSpan="10" className="text-center">Yüklənir...</td></tr>}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
});

export default Product;
